import React from "react";
import { DefaultActivityView } from "@components/Activity";

const PollView = ({ options = [], setModalState }) => (
  <DefaultActivityView options={options} setModalState={setModalState} />
);

export default PollView;
